// extracted by mini-css-extract-plugin
module.exports = {"navbarBrand":"cbbfcdd","logo":"_6e56ff7"};